<app-list-subheader/>
@let data = data$ | async;
@if (isTotalCountSelectable() && isAllRowsSelected() && !!data && numberOfTotalRowsSelectable() < data.totalCount) {
  <div class="align-middle mt-2 mb-2 ms-3">
    @if (isTotalCountSelected()) {
      {{ totalCountSelectedLabelKey() | translate: {p1: data?.totalCount} }}
      <button role="button"
         [class]="ButtonType.Light | buttontypepipe"
         class="btn-sm btn"
         (click)="onClickSetFlagIsAllSelected()">
        {{ "GLOBAL_LBL_CANCEL_ALL_FILTERED" | translate }}
      </button>
    } @else {
      <button role="button" [class]="ButtonType.Light | buttontypepipe"
              class="btn-sm btn"
              (click)="onClickSetFlagIsAllSelected()">
        {{ totalCountSelectedLabelKey() | translate: {p1: data?.totalCount} }}
        </button>
    }
  </div>
}
@if (this.viewType$ | async; as viewType) {
  @if (viewType == 'TreeView') {
    <ag-grid-angular
      class="ag-theme-alpine data-grid "
      [gridOptions]="gridOptions"
      [rowData]="data?.data"
      (gridReady)="onGridReady($event)"
      (sortChanged)="onSortChanged($event)"
      (gridSizeChanged)="onGridSizeChanged($event)"
      (rowDataUpdated)="onRowDataUpdated()"
      (selectionChanged)="onSelectionChanged($event)"
      [overlayNoRowsTemplate]="this.noRowsTemplate"
      [rowSelection]="this.rowSelectionOptions"
      [context]="context"
      [alwaysShowHorizontalScroll]="true"
    ></ag-grid-angular>
  }
  @if (viewType == 'KanbanView') {
    <app-kanban-view
      [data]="data?.data"
      [entity]="(this.view$ | async)?.entity"
    ></app-kanban-view>
  }
}
